<template>
  <div>
    <h3>Questions</h3>
    <mdb-card class="form-card">
      <form @submit.prevent="searchQuestions">
        <mdb-card-body>
          <mdb-card-title>Filtrer les questions</mdb-card-title>
          <mdb-card-text>Laissez les champs vide si vous ne voulez pas filtrer...</mdb-card-text>
          <mdb-autocomplete :data="recommendations.tags" label="Filtrer par tag" v-model.trim="newTag"></mdb-autocomplete>
          <!-- <tag-selector class="theme-material" name="tags" v-model="tags" /> -->
          <mdb-autocomplete :data="recommendations.pseudos" label="Filtrer par auteur" v-model.trim="author"></mdb-autocomplete>
          <br />
          <mdb-card-text>Trier par</mdb-card-text>
          <mdb-input
            type="radio"
            id="order-1"
            name="order"
            radioValue="score"
            v-model="order"
            label="Score"
          />
          <mdb-input
            type="radio"
            id="order-2"
            name="order"
            radioValue="createdTime"
            v-model="order"
            label="Date"
          />
          <br />
          <mdb-btn type="submit" class="orange darken-1" rounded size="md">Chercher</mdb-btn>
        </mdb-card-body>
      </form>
    </mdb-card>
    <br />
    <div v-if="getQuestions.length > 0">
      <ListQuestions
        :questions="getQuestions"
        votable="true"
        @vote-up="voteUp"
        @vote-down="voteDown"
      ></ListQuestions>
      <mdb-btn v-if="hasMoreToLoad" @click="searchQuestions" class="orange darken-1" rounded size="md">Plus...</mdb-btn>
    </div>
    <p v-if="getQuestions.length == 0">Il n'y a pas de résultats...</p>
    <mdb-spinner v-if="searching" color="yellow" />
  </div>
</template>

<script>
import TagSelector from "vue-tag-selector";
import { mapState, mapActions, mapGetters } from "vuex";
import {
  mdbCard,
  mdbCardBody,
  mdbCardTitle,
  mdbAlert,
  mdbCardText,
  mdbBtnGroup,
  mdbSpinner,
  mdbAutocomplete
} from "mdbvue";
import ListQuestions from "./ListQuestions";
export default {
  name: "AllQuestions",
  components: {
    TagSelector,
    ListQuestions,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
    mdbAlert,
    mdbCardText,
    mdbSpinner,
    mdbAutocomplete
  },
  computed: {
    ...mapGetters("questions", ["getQuestions","hasMoreToLoad"]),
    ...mapState("globalRecommendations",["recommendations"]),
  },
  data() {
    return {
      newTag:"",
      tags: [],
      order: "score",
      searching: false,
      author: ""
    };
  },
  methods: {
    ...mapActions("questions", ["bindMoreQuestions", "vote"]),
    voteUp: function(question) {
      this.vote({ question, vote: 1 });
    },
    voteDown: function(question) {
      this.vote({ question, vote: -1 });
    },
    searchQuestions: async function() {
      this.searching = true;
      await this.bindMoreQuestions({
        tags: this.newTag ? [this.newTag] : [],
        order: this.order,
        author: this.author
      });
      this.searching = false;
    }
  },
  mounted: function() {
    if (this.getQuestions.length == 0) this.bindMoreQuestions({});
  }
};
</script>

<style>
</style>